<ng-container *ngIf="hasNotifyMe">
  <div class="notify-me-text-container">
    <div class="text-container">
      <mat-icon class="material-icons-sharp light md-12 ml-1">info</mat-icon>
      <div class="text" [innerHTML]="'stockNotification.notifyMeBulkOrder' | cxTranslate"></div>
    </div>
    <button class="btn secondary-btn btn-block btn-notify-me" type="button" (click)="notifyMeModal()">
      {{ 'stockNotification.viewOutOfStock' | cxTranslate }}
    </button>
  </div>
</ng-container>

<div
  class="order-form-container d-flex flex-column mb-5"
  *ngIf="displayOrderForm && baseProduct$ | async as baseProduct; else displayOrderFormError"
>
  <mat-divider></mat-divider>
  <span class="text-xl-left text-sm-right"
    >{{ showSrp ? ('orderForm.showingSrpPrices' | cxTranslate) : ('orderForm.showingDealerPrices' | cxTranslate)
    }}<span class="gst-label" *ngIf="(showGstExclusive$ | async) && !showSrp">{{ 'gst.exclusive' | cxTranslate }}</span
    ><span class="gst-label" *ngIf="(showGstInclusive$ | async) && showSrp">{{
      'gst.inclusive' | cxTranslate
    }}</span></span
  >
  <form novalidate [formGroup]="orderFormGroup">
    <div class="product-matrix-wrapper">
      <div
        class="product-matrix-container d-flex flex-column flex-md-row"
        [style.min-height.px]="
          !isMobile ? customHeaderHeight[i] + currentBodyHeight : customHeaderHeight[i] + currentBodyHeight + 113
        "
        *ngFor="let variant of baseProduct.variantMatrix; let i = index"
      >
        <div class="product-matrix-item-column">
          <div class="header d-flex align-items-center" [style.height.px]="!isMobile ? customHeaderHeight[i] : 28">
            <div class="color text-center">
              <span
                *ngIf="variantCategoryCount === 1"
                class="text-uppercase"
                [attr.data-first-variant-category]="variant.parentVariantCategory.name | lowercase"
              >
                {{ variant.variantValueCategory.name }}
              </span>
              <span
                *ngIf="variantCategoryCount === 2"
                class="text-uppercase"
                [attr.data-first-variant-category]="variant.parentVariantCategory.name | lowercase"
              >
                {{ variant.variantValueCategory.name }}
              </span>
              <span
                *ngIf="variantCategoryCount === 3"
                class="text-uppercase"
                [attr.data-first-variant-category]="variant.parentVariantCategory.name | lowercase"
              >
                {{ variant.variantValueCategory.name }}
              </span>
            </div>
          </div>
          <ng-container *ngIf="variantCategoryCount !== 3; else variantCategoryCount3">
            <div class="body d-flex align-items-start">
              <div class="item-details d-flex align-items-start">
                <div class="image" [class.snah-fish-country]="isFishAndSnah">
                  <cx-media
                    *ngIf="variantCategoryCount === 1; else imageForTwoOrThreeVariantCategory"
                    [container]="getImageRendition(getFirstVariantProductImage(variant.variantOption.code))"
                    format="product"
                    [class.is-missing-fish]="businessType === 'fish'"
                    [class.is-snah-country]="showActiveSnahCountry$ | async"
                    (click)="productImageModal(variant.variantOption.code)"
                    removeImageTitleAttr
                  ></cx-media>
                  <ng-template #imageForTwoOrThreeVariantCategory>
                    <cx-media
                      [container]="
                        getImageRendition(getFirstVariantProductImage(variant.elements[0].variantOption.code))
                      "
                      format="product"
                      [class.is-missing-fish]="businessType === 'fish'"
                      [class.is-snah-country]="showActiveSnahCountry$ | async"
                      (click)="productImageModal(variant.elements[0].variantOption.code)"
                      removeImageTitleAttr
                    ></cx-media>
                  </ng-template>
                </div>
                <div class="sku">
                  <app-tooltip-text
                    *ngIf="variantCategoryCount === 1; else productNameForTwoOrThreeVariantCategory"
                    class="d-block"
                    [tooltipContent]="getFirstVariantProductName(variant.variantOption.code)"
                    [content]="getFirstVariantProductName(variant.variantOption.code)"
                    placement="bottom"
                  ></app-tooltip-text>
                  <ng-template #productNameForTwoOrThreeVariantCategory>
                    <app-tooltip-text
                      class="d-block"
                      [tooltipContent]="getFirstVariantProductName(variant.elements[0].variantOption.code)"
                      [content]="getFirstVariantProductName(variant.elements[0].variantOption.code)"
                      placement="bottom"
                    ></app-tooltip-text>
                  </ng-template>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #variantCategoryCount3>
            <div class="body d-flex align-items-start" *ngFor="let element of categoryItems[i]">
              <div class="item-details d-flex align-items-start">
                <div class="image" [class.snah-fish-country]="isFishAndSnah">
                  <cx-media
                    [container]="getImageRendition(getFirstVariantProductImage(element.variantOption.code))"
                    format="product"
                    [class.is-missing-fish]="businessType === 'fish'"
                    [class.is-snah-country]="showActiveSnahCountry$ | async"
                    (click)="productImageModal(element.variantOption.code)"
                    removeImageTitleAttr
                  ></cx-media>
                </div>
                <div class="sku">
                  <app-tooltip-text
                    class="d-block"
                    [tooltipContent]="getFirstVariantProductName(element.variantOption.code)"
                    [content]="getFirstVariantProductName(element.variantOption.code)"
                    placement="bottom"
                  ></app-tooltip-text>
                  <span
                    [attr.data-second-variant-category]="element?.variantValueCategory?.name | lowercase"
                    class="d-block"
                    [innerHTML]="element?.variantValueCategory?.name"
                  >
                  </span>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
        <div
          class="product-matrix-variant-column flex-grow-1"
          [style.min-height.px]="customHeaderHeight[i] + currentBodyHeight"
        >
          <div
            #headerElement
            [class]="'header d-inline-flex align-items-center' + setCustomHeaderHeight(headerElement, i)"
          >
            <div class="size-container d-flex flex-nowrap flex-row">
              <div class="size text-left" *ngFor="let element of variant.elements">
                <span
                  *ngIf="variantCategoryCount === 2"
                  [attr.data-second-variant-category]="element.parentVariantCategory.name | lowercase"
                  class="text-uppercase"
                  [class.text-break]="isOneWord(element.variantValueCategory.name)"
                  >{{ element.variantValueCategory.name }}</span
                >
                <span
                  *ngIf="variantCategoryCount === 3"
                  [attr.data-third-variant-category]="element.parentVariantCategory.name | lowercase"
                  class="text-uppercase"
                  [class.text-break]="isOneWord(element.variantValueCategory.name)"
                  >{{ element.variantValueCategory.name }}</span
                >
              </div>
            </div>
          </div>
          <ng-container *ngIf="variantCategoryCount !== 3; else sizeVariantCategoryCount3">
            <div #bodyElement class="body d-flex align-items-start">
              <div class="size-details-container d-flex flex-nowrap flex-row h-100">
                <ng-container *ngIf="variantCategoryCount === 1; else sizeVariantCategoryCount2and3">
                  <div class="size-details d-flex flex-column align-items-start">
                    <div class="price" [class.loading]="!dealerPrice(variant.variantOption.code) && hasDealerPrice">
                      <span *ngIf="!showSrp">
                        <div
                          class="spinner-shimano-wrapper-dp spinner-shimano-wrapper-dp-pb"
                          *ngIf="!dealerPrice(variant.variantOption.code); else dealerPriceReady"
                        >
                          <ng-container *ngIf="tooltipIconConfig$ | async as tooltipIconConfig">
                            <div class="spinner-shimano" *ngIf="hasDealerPrice">
                              <div class="spinner-shimano-mt-ml"></div>
                            </div>
                            <div
                              class="no-dealer-price no-dealer-price-order-form"
                              *ngIf="!hasDealerPrice && !tooltipIconConfig?.enabled; else noDealerPriceTooltipVccNot3"
                            ></div>
                            <ng-template #noDealerPriceTooltipVccNot3>
                              <ng-container
                                [ngTemplateOutlet]="noDealerPriceTooltip"
                                [ngTemplateOutletContext]="{ tooltipIconConfig: tooltipIconConfig }"
                              ></ng-container>
                            </ng-template>
                          </ng-container>
                        </div>
                        <ng-template #dealerPriceReady>
                          {{ dealerPrice(variant.variantOption.code) }}
                        </ng-template>
                      </span>
                      <span *ngIf="showSrp">{{ getSrpPriceFormattedValue(variant.variantOption.code) }}</span>
                    </div>
                    <div class="quantity">
                      <fieldset
                        [disabled]="
                          isOutOfStock(variant.variantOption.code) || !dealerPriceValue(variant.variantOption.code)
                        "
                      >
                        <input
                          class="form-control"
                          type="number"
                          min="0"
                          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); this.value = this.value.replace(/^[0]+/g,'')"
                          maxlength="3"
                          [class.backorder]="isBackOrder(variant.variantOption.code)"
                          [class.out-of-stock]="
                            isOutOfStock(variant.variantOption.code) || !dealerPrice(variant.variantOption.code)
                          "
                          placeholder="0"
                          [formControlName]="variant.variantOption.code"
                          (change)="updateOrderFormDetails(showSrp)"
                          (keypress)="numberOnly($event)"
                          (blur)="updateOrderFormDetails(showSrp)"
                        />
                      </fieldset>
                    </div>
                    <div class="stock-count" *ngIf="asmEnabled === 'true' && hasStockLevel(variant.variantOption.code)">
                      {{ getStockLevel(variant.variantOption.code) }}
                    </div>
                  </div>
                </ng-container>
                <ng-template #sizeVariantCategoryCount2and3>
                  <div
                    class="size-details d-flex flex-column align-items-start"
                    *ngFor="let element of variant.elements"
                  >
                    <div class="price" [class.loading]="!dealerPrice(element.variantOption.code) && hasDealerPrice">
                      <span *ngIf="!showSrp">
                        <div
                          class="spinner-shimano-wrapper-dp spinner-shimano-wrapper-dp-pb"
                          *ngIf="!dealerPrice(element.variantOption.code); else dealerPriceReady"
                        >
                          <ng-container *ngIf="tooltipIconConfig$ | async as tooltipIconConfig">
                            <div class="spinner-shimano" *ngIf="hasDealerPrice">
                              <div class="spinner-shimano-mt-ml"></div>
                            </div>
                            <div
                              class="no-dealer-price no-dealer-price-order-form"
                              *ngIf="!hasDealerPrice && !tooltipIconConfig?.enabled; else noDealerPriceTooltipVcc2and3"
                            ></div>
                            <ng-template #noDealerPriceTooltipVcc2and3>
                              <ng-container
                                [ngTemplateOutlet]="noDealerPriceTooltip"
                                [ngTemplateOutletContext]="{ tooltipIconConfig: tooltipIconConfig }"
                              ></ng-container>
                            </ng-template>
                          </ng-container>
                        </div>
                        <ng-template #dealerPriceReady>
                          {{ dealerPrice(element.variantOption.code) }}
                        </ng-template>
                      </span>
                      <span *ngIf="showSrp">{{ getSrpPriceFormattedValue(element.variantOption.code) }}</span>
                    </div>
                    <div class="quantity">
                      <fieldset
                        [disabled]="
                          isOutOfStock(element.variantOption.code) || !dealerPrice(element.variantOption.code)
                        "
                      >
                        <input
                          class="form-control"
                          type="number"
                          min="0"
                          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); this.value = this.value.replace(/^[0]+/g,'')"
                          maxlength="3"
                          [class.backorder]="isBackOrder(element.variantOption.code)"
                          [class.out-of-stock]="
                            isOutOfStock(element.variantOption.code) || !dealerPrice(element.variantOption.code)
                          "
                          placeholder="0"
                          [formControlName]="element.variantOption.code"
                          (change)="updateOrderFormDetails(showSrp)"
                          (keypress)="numberOnly($event)"
                          (blur)="updateOrderFormDetails(showSrp)"
                        />
                      </fieldset>
                    </div>
                    <div class="stock-count" *ngIf="asmEnabled === 'true' && hasStockLevel(element.variantOption.code)">
                      {{ getStockLevel(element.variantOption.code) }}
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </ng-container>
          <ng-template #sizeVariantCategoryCount3>
            <ng-container *ngFor="let elements of categoryItems[i]">
              <div #bodyElement class="body d-flex align-items-start">
                <div class="size-details-container d-flex flex-nowrap flex-row h-100">
                  <ng-container *ngFor="let element of elements?.subVariantElements">
                    <div class="size-details d-flex flex-column align-items-start">
                      <ng-container *ngIf="(element | json) != '{}'">
                        <div
                          class="price"
                          [class.loading]="!dealerPrice(element[0].variantOption.code) && hasDealerPrice"
                        >
                          <span *ngIf="!showSrp">
                            <div
                              class="spinner-shimano-wrapper-dp spinner-shimano-wrapper-dp-pb"
                              *ngIf="!dealerPrice(element[0].variantOption.code); else dealerPriceReady"
                            >
                              <ng-container *ngIf="tooltipIconConfig$ | async as tooltipIconConfig">
                                <div class="spinner-shimano" *ngIf="hasDealerPrice">
                                  <div class="spinner-shimano-mt-ml"></div>
                                </div>
                                <div
                                  class="no-dealer-price no-dealer-price-order-form"
                                  *ngIf="!hasDealerPrice && !tooltipIconConfig?.enabled; else noDealerPriceTooltipVcc3"
                                ></div>
                                <ng-template #noDealerPriceTooltipVcc3>
                                  <ng-container
                                    [ngTemplateOutlet]="noDealerPriceTooltip"
                                    [ngTemplateOutletContext]="{ tooltipIconConfig: tooltipIconConfig }"
                                  ></ng-container>
                                </ng-template>
                              </ng-container>
                            </div>
                            <ng-template #dealerPriceReady>
                              {{ dealerPrice(element[0].variantOption.code) }}
                            </ng-template>
                          </span>
                          <span *ngIf="showSrp">{{ getSrpPriceFormattedValue(element[0].variantOption.code) }}</span>
                        </div>
                        <div class="quantity">
                          <fieldset
                            [disabled]="
                              isOutOfStock(element[0].variantOption.code) || !dealerPrice(element[0].variantOption.code)
                            "
                          >
                            <input
                              class="form-control"
                              type="number"
                              min="0"
                              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); this.value = this.value.replace(/^[0]+/g,'')"
                              maxlength="3"
                              [class.backorder]="isBackOrder(element[0].variantOption.code)"
                              [class.out-of-stock]="
                                isOutOfStock(element[0].variantOption.code) ||
                                !dealerPrice(element[0].variantOption.code)
                              "
                              placeholder="0"
                              [formControlName]="element[0].variantOption.code"
                              (change)="updateOrderFormDetails(showSrp)"
                              (keypress)="numberOnly($event)"
                              (blur)="updateOrderFormDetails(showSrp)"
                            />
                          </fieldset>
                        </div>
                        <div
                          class="stock-count"
                          *ngIf="asmEnabled === 'true' && hasStockLevel(element[0].variantOption.code)"
                        >
                          {{ getStockLevel(element[0].variantOption.code) }}
                        </div>
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </ng-template>
        </div>
      </div>
    </div>
  </form>
</div>
<ng-template #displayOrderFormError>
  <ng-container *ngIf="baseProduct$ | async as baseProduct">
    <div class="no-order-form error" *ngIf="!displayOrderForm && !baseProduct?.baseProduct">
      {{ 'orderForm.noOrderForm' | cxTranslate }}
    </div>
  </ng-container>
</ng-template>
<ng-template #noDealerPriceTooltip let-tooltipIconConfig="tooltipIconConfig">
  <app-tooltip-icon
    *ngIf="!hasDealerPrice && tooltipIconConfig?.enabled"
    [noDealerPriceIcon]="tooltipIconConfig?.noDealerPriceIcon"
    dealerPriceIconContainerClass="no-dealer-price-order-form"
    placement="bottom-right"
    [tooltipContent]="'tooltip.hasNoDealerPrice' | cxTranslate"
    [closeOnScroll]="tooltipIconConfig?.closeOnScroll"
  ></app-tooltip-icon>
</ng-template>
